/**
 * Builds a CSS `var(--name)` reference string from a custom property name.
 *
 * Used to bridge the Tailwind / design-system CSS custom properties into the
 * styled-components theme (see the theme overrides in `@savgroup-front-common/core`).
 *
 * An optional `fallback` is emitted as the CSS `var()` fallback value, so the
 * token still resolves in apps that don't load the Tailwind stylesheet.
 */
export const cssVar = (name: string, fallback?: string): string =>
  fallback ? `var(${name}, ${fallback})` : `var(${name})`;
